import { render, staticRenderFns } from "./AreasList.vue?vue&type=template&id=08ef2730&scoped=true"
import script from "./AreasList.vue?vue&type=script&lang=js"
export * from "./AreasList.vue?vue&type=script&lang=js"
import style0 from "./AreasList.vue?vue&type=style&index=0&id=08ef2730&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ef2730",
  null
  
)

export default component.exports